import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function PageHeader({
  crumb,
  title,
  subtitle,
  children,
}: {
  crumb: Crumb[];
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}) {
  return (
    <section className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <nav aria-label="面包屑" className="text-xs text-foreground-600">
          <ol className="flex flex-wrap items-center gap-1.5">
            {crumb.map((c, idx) => (
              <li key={c.label} className="flex items-center gap-1.5">
                {c.to ? (
                  <Link to={c.to} className="hover:text-primary-700">
                    {c.label}
                  </Link>
                ) : (
                  <span className="font-bold text-foreground-900">{c.label}</span>
                )}
                {idx < crumb.length - 1 ? (
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                ) : null}
              </li>
            ))}
          </ol>
        </nav>
        <h1 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {subtitle}
          </p>
        ) : null}
        {children}
      </div>
    </section>
  );
}